import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/ReportingGroups'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { TabNavItems, TabContent, TabPane } from '@/components/tabs'
import { withPermissions } from '@/decorators/withPermissions'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import { Main, MainTop, MainTopTitle, MainBody, WhiteBox } from '@/components/Layout'
import {
  BsrsGrid,
  EnumCell,
  EnumFilterCell,
  commandColumnProps
} from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { Button } from 'reactstrap'
import context from '@/context'
import Icon from '@/components/Icon'
import { TemplatesCell, templateCellExport } from '@/components/reporting/templatesCell'
import { reportGroupStatus } from '@/enums/reportGroupStatus'
import moment from 'moment'

@localized()
@withPermissions()
class ReportingGroups extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      activeTab: 'regular',
      gridKey: moment()
    }
  }
  toggleTab = (activeTab) => {
    this.setState({ ...this.state, activeTab })
  }

  reloadGrid = () => {
    setTimeout(() => this.setState({ ...this.state, gridKey: moment() }), 500)
  }

  openNewReportingGroupDialog (forecasting) {
    this.props.openDialog({
      dialogType: dialogTypes.addNewReportingGroup,
      onAction: (item) => this.props.create(item, this.reloadGrid),
      localize: this.props.localize,
      localizeProps: this.props.localizeProps,
      forecasting
    })
  }
  templatesCell = (props) => <TemplatesCell {...props} locale={this.props.locale} localizeValue={this.props.localizeValue} />

  renderTab (forecasting) {
    const { localize, reportingGroups, isGranted } = this.props
    const isReadOnly = !isGranted('CanManageReportGroups') || reportingGroups.saving === true
    const enumName = 'ReportGroupStatus'

    const enableItem = (item) => {
      context.api.reportGroupsService.enable(item.id)
        .then(() => this.reloadGrid()).catch()
    }

    const disableItem = (item) => {
      context.api.reportGroupsService.disable(item.id)
        .then(() => this.reloadGrid()).catch()
    }

    return (
      <React.Fragment>
        <p>
          <Button color='primary' disabled={isReadOnly} className='btn-sm' onClick={() => this.openNewReportingGroupDialog(forecasting)}>
            <Icon name='plus' /> <span><Resx name={forecasting ? 'Reporting.AddForecastingGroupButton' : 'Reporting.AddRegularGroupButton'} /></span>
          </Button>
        </p>
        <BsrsGrid
          persistenceId={'reporting-groups' + (forecasting ? '-forecasting' : '')}
          dataSource={request => context.api.reportGroupsService.getAllTableData(forecasting, request)}
          lastReloadedAt={this.state.gridKey}>
          <Column field='name' title={localize('Common.Name')} editable={false} />
          <Column field='state' title={localize('Reporting.State')} editable={false}
            cell={EnumCell({ localize, enumName })}
            filterCell={EnumFilterCell({ localize, enumName }, reportGroupStatus.values)} />
          <Column field='templates' title={localize('Reporting.ReportingTemplates')} editable={false} sortable={false} filterable={false} cell={this.templatesCell} cellExport={templateCellExport} />
          <Column {...commandColumnProps({
            detailUrl: x => `/reporting-groups/${x.id}`,
            onDisableClick: x => disableItem(x),
            onEnableClick: x => enableItem(x),
            itemIsActive: x => x.state === reportGroupStatus.enum.Enabled,
            canToggleActivation: !isReadOnly
          })} />
        </BsrsGrid>
      </React.Fragment>
    )
  }
  render () {
    return (
      <Main>
        <MainTop>
          <MainTopTitle>
            <Resx name='Reporting.ReportingGroupsTitle' />
          </MainTopTitle>
        </MainTop>
        <MainBody transparent>
          <WhiteBox>
            <TabNavItems
              activeTabId={this.state.activeTab}
              onClick={this.toggleTab}
              items={[
                { id: 'regular', text: 'Reporting.Regular' },
                { id: 'forecast', text: 'Reporting.Forecasting' }
              ]} />

            <TabContent renderActiveOnly activeTab={this.state.activeTab}>
              <TabPane tabId='regular'>
                {this.renderTab(false)}
              </TabPane>
              <TabPane tabId='forecast'>
                {this.renderTab(true)}
              </TabPane>
            </TabContent>
          </WhiteBox>
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportingGroups: state.reportingGroups,
    ...ownProps
  }
}

const mapDispatchToProps = {
  create: actionCreators.create,
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportingGroups)



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingGroups/reportingGroups.js